var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7667 10.167V17.8337C10.7667 18.2337 10.9389 18.5337 11.2834 18.7337C11.6278 18.9337 11.9667 18.9225 12.3 18.7003L18.3334 14.8337C18.6445 14.6337 18.8 14.3559 18.8 14.0003C18.8 13.6448 18.6445 13.367 18.3334 13.167L12.3 9.30033C11.9667 9.0781 11.6278 9.06699 11.2834 9.26699C10.9389 9.46699 10.7667 9.76699 10.7667 10.167ZM14 27.3337C12.1778 27.3337 10.4556 26.9837 8.83335 26.2837C7.21113 25.5837 5.79446 24.6281 4.58335 23.417C3.37224 22.2059 2.41669 20.7892 1.71669 19.167C1.01669 17.5448 0.666687 15.8225 0.666687 14.0003C0.666687 12.1781 1.01669 10.4559 1.71669 8.83366C2.41669 7.21144 3.37224 5.79477 4.58335 4.58366C5.79446 3.37255 7.21113 2.41699 8.83335 1.71699C10.4556 1.01699 12.1778 0.666992 14 0.666992C15.8222 0.666992 17.5445 1.01699 19.1667 1.71699C20.7889 2.41699 22.2056 3.37255 23.4167 4.58366C24.6278 5.79477 25.5834 7.21144 26.2834 8.83366C26.9834 10.4559 27.3334 12.1781 27.3334 14.0003C27.3334 15.8225 26.9834 17.5448 26.2834 19.167C25.5834 20.7892 24.6278 22.2059 23.4167 23.417C22.2056 24.6281 20.7889 25.5837 19.1667 26.2837C17.5445 26.9837 15.8222 27.3337 14 27.3337Z",
    fill: "url(#paint0_linear_741_10697)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_741_10697",
    x1: 9.16668,
    y1: 4.33366,
    x2: 17,
    y2: 27.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1263DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#448FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.17e694a2b8d018a6daf6a6de8c28d79b.svg";
export { ForwardRef as ReactComponent };